module.exports = __webpack_public_path__ + "81c29532385e062b6fbfdf1138c6f406.MP3";